import React, { useEffect, useState } from "react";
import "../components/styles/Login.css";
import Action from "../components/Action";
import LoadSimple from "../components/LoadSimple";

const Login = ({
    onLogin,
    msgErrorLogin,
    setMsgErrorLogin,
    token,
    setToken,
    userData,
    setUserData,
    server,
}) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [loginData, setLoginData] = useState({ email: "", password: "" });
    const [disabled, setDisabled] = useState(true);
    const [userVal, setUserVal] = useState(true);
    const [isRecovering, setIsRecovering] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    // ─── NUEVO: solo UI, mostrar/ocultar contraseña ─────────────────────────
    const [showPassword, setShowPassword] = useState(false);

    const handleRecovery = async () => {
        setIsSuccess(false);

        if (loginData.email === "") {
            setUserVal(false);
            setMsgErrorLogin("Ingresa tu correo para recuperarla.");
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(`${server.url}/api/v1/auth/forgot-password`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email: loginData.email }),
            });

            const result = await response.json();

            if (response.ok) {
                setIsSuccess(true);
                setMsgErrorLogin(result.message || "Si el correo existe, se enviaron instrucciones.");
                setUserVal(false);
            } else {
                setIsSuccess(false);
                setUserVal(false);
                setMsgErrorLogin(result.message || result.detail || "Error al solicitar recuperación.");
            }
        } catch (error) {
            console.error("Error:", error);
            setIsSuccess(false);
            setUserVal(false);
            setMsgErrorLogin("Error de conexión con el servidor.");
        }

        setLoading(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setLoginData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    useEffect(() => {
        if (localStorage.getItem("ErrorLogin") == "true") {
            setUserVal(false);
            setIsSuccess(false);
            setMsgErrorLogin(localStorage.getItem("MsgErrorLogin"));
            localStorage.setItem("MsgErrorLogin", "");
            localStorage.setItem("ErrorLogin", false);
        }
    }, []);

    useEffect(() => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValidEmail = emailRegex.test(loginData.email);

        if (isRecovering) {
            if (loginData.email === "" || !isValidEmail) {
                setDisabled(true);
            } else {
                setDisabled(false);
            }
        } else {
            if (loginData.email === "" || loginData.password === "") {
                setDisabled(true);
            } else {
                setDisabled(false);
            }
        }
    }, [loginData, isRecovering]);

    const handleSubmit = async (e) => {
        setIsSuccess(false);
        setUserVal(true);
        localStorage.setItem("MsgErrorLogin", "");
        localStorage.setItem("ErrorLogin", false);
        setLoading(true);
        const formData = new URLSearchParams();
        formData.append("username", loginData.email);
        formData.append("password", loginData.password);
        formData.append("grant_type", "");
        formData.append("scope", "");
        formData.append("client_id", "");
        formData.append("client_secret", "");

        try {
            const response = await fetch(
                server.url + "/api/v1/auth/login",
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body: formData,
                }
            );

            if (response.ok) {
                const data = await response.json();
                setLoading(false);
                setData(data);
                localStorage.setItem("user_id", data.user_id);
                localStorage.setItem("user_cassia", loginData.email);
                localStorage.setItem(
                    "password_cassia_" + data.data.access_token,
                    loginData.password
                );
                setUserVal(true);
                onLogin(data);
            } else {
                setMsgErrorLogin(
                    "Correo o Contraseña incorrectos, favor de intentar de nuevo."
                );
                setIsSuccess(false);
                setUserVal(false);
                localStorage.setItem("ErrorLogin", true);
                throw new Error("Error en la solicitud");
            }
        } catch (error) {
            setLoading(false);
            setError(error);
            setIsSuccess(false);
            if (localStorage.getItem("ErrorLogin") == "false") {
                setMsgErrorLogin("Error de conexion con el server");
            }
            setUserVal(false);
        }
    };

    const { email, password } = loginData;

    // ═══════════════════════════════════════════════════════════════════════
    // PALETA CLEAN BLUE (solo para el panel derecho rediseñado)
    // ═══════════════════════════════════════════════════════════════════════
    const C = {
        bl: '#1a56db',
        blDark: '#0f2d5e',
        bl5: '#e8f0fe',
        txt: '#0f172a',
        txt2: '#334155',
        txt3: '#64748b',
        txt4: '#94a3b8',
        b1: '#e2e8f0',
        b2: '#cbd5e1',
        bg: '#f8fafc',
        wh: '#ffffff',
        gr: '#4BB543',
        grSoft: 'rgba(75, 181, 67, 0.15)',
        red: '#ff4d4d',
        redSoft: 'rgba(255, 77, 77, 0.15)',
    };

    return (
        <div className="main-login">
            {/* ═══════════════════════════════════════════════════════════════
                PANEL IZQUIERDO — INTACTO (tal cual estaba en tu original)
                ═══════════════════════════════════════════════════════════════ */}
            <div className="cont-login rigth-login">
                <div className="cont-img-back">
                    <div className="cont-img">
                        <img
                            src="ciberseguridad-seguritech.png"
                            className="img-show"
                            alt="Logo"
                        />
                    </div>
                    <div className="cont-img">
                        <img src="monitoreo-2.jpeg" className="img-show" alt="Logo" />
                    </div>
                </div>
                <div className="cont-shadow">
                    <img
                        src="SaimonTech_logo_blanco.png"
                        className="logo-login"
                        alt="Logo"
                    />
                </div>
            </div>

            {/* ═══════════════════════════════════════════════════════════════
                PANEL DERECHO — REDISEÑADO (Clean Blue)
                Conserva la clase 'cont-login left-login' para que el CSS
                global del split-screen siga funcionando. Por dentro, todo
                el formulario es nuevo con estilos inline.
                ═══════════════════════════════════════════════════════════════ */}
            <div className="cont-login left-login">
                {/* Logo móvil (visible solo en pantallas pequeñas, lo controla tu Login.css con .cont-shadow-movil) */}
                <div className="cont-shadow-movil">
                    <img
                        src="SaimonTech_logo_blanco.png"
                        className="logo-login"
                        alt="Logo"
                    />
                </div>

                <div
                    style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '24px',
                        boxSizing: 'border-box',
                    }}
                >
                    <div
                        style={{
                            width: '100%',
                            maxWidth: 380,
                            display: 'flex',
                            flexDirection: 'column',
                            background: C.wh,
                            borderRadius: 14,
                            padding: '36px 32px',
                            boxShadow: '0 10px 40px rgba(15, 45, 94, 0.08)',
                            border: `1px solid ${C.b1}`,
                            boxSizing: 'border-box',
                        }}
                    >
                        {/* Encabezado */}
                        <div style={{ marginBottom: 28 }}>
                            <h1
                                style={{
                                    fontSize: 22,
                                    fontWeight: 600,
                                    color: 'var(--third-color)',
                                    margin: '0 0 6px 0',
                                    letterSpacing: '-0.01em',
                                }}
                            >
                                {isRecovering ? 'Recuperar contraseña' : 'Bienvenido'}
                            </h1>
                            <p style={{ fontSize: 13, color: C.txt3, margin: 0 }}>
                                {isRecovering
                                    ? 'Ingresa tu correo y te enviaremos las instrucciones'
                                    : 'Ingresa tus credenciales para continuar'}
                            </p>
                        </div>

                        {/* Formulario */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                            {/* Campo Correo */}
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                                <label
                                    style={{
                                        fontSize: 11,
                                        fontWeight: 600,
                                        color: C.txt3,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.04em',
                                    }}
                                >
                                    Correo electrónico
                                </label>
                                <div style={{ position: 'relative' }}>
                                    <svg
                                        width="15"
                                        height="15"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke={C.txt4}
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        style={{
                                            position: 'absolute',
                                            left: 12,
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            pointerEvents: 'none',
                                        }}
                                    >
                                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                        <polyline points="22,6 12,13 2,6" />
                                    </svg>
                                    <input
                                        required
                                        name="email"
                                        type="text"
                                        value={email}
                                        onChange={handleChange}
                                        placeholder="nombre@empresa.com"
                                        style={{
                                            width: '100%',
                                            height: 42,
                                            padding: '0 14px 0 40px',
                                            border: `1px solid ${C.b1}`,
                                            borderRadius: 8,
                                            background: C.wh,
                                            fontSize: 14,
                                            color: C.txt,
                                            outline: 'none',
                                            boxSizing: 'border-box',
                                            transition: 'border-color 0.15s, box-shadow 0.15s',
                                        }}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = C.bl;
                                            e.target.style.boxShadow = `0 0 0 3px ${C.bl5}`;
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = C.b1;
                                            e.target.style.boxShadow = 'none';
                                        }}
                                    />
                                </div>
                            </div>

                            {/* Campo Contraseña (oculto en modo recuperar) */}
                            {!isRecovering && (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                                    <label
                                        style={{
                                            fontSize: 11,
                                            fontWeight: 600,
                                            color: C.txt3,
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.04em',
                                        }}
                                    >
                                        Contraseña
                                    </label>
                                    <div style={{ position: 'relative' }}>
                                        <svg
                                            width="15"
                                            height="15"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke={C.txt4}
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            style={{
                                                position: 'absolute',
                                                left: 12,
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                pointerEvents: 'none',
                                            }}
                                        >
                                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                        </svg>
                                        <input
                                            required
                                            name="password"
                                            type={showPassword ? 'text' : 'password'}
                                            value={password}
                                            onChange={handleChange}
                                            placeholder="••••••••"
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' && !disabled && !loading) {
                                                    handleSubmit();
                                                }
                                            }}
                                            style={{
                                                width: '100%',
                                                height: 42,
                                                padding: '0 42px 0 40px',
                                                border: `1px solid ${C.b1}`,
                                                borderRadius: 8,
                                                background: C.wh,
                                                fontSize: 14,
                                                color: C.txt,
                                                outline: 'none',
                                                boxSizing: 'border-box',
                                                transition: 'border-color 0.15s, box-shadow 0.15s',
                                            }}
                                            onFocus={(e) => {
                                                e.target.style.borderColor = C.bl;
                                                e.target.style.boxShadow = `0 0 0 3px ${C.bl5}`;
                                            }}
                                            onBlur={(e) => {
                                                e.target.style.borderColor = C.b1;
                                                e.target.style.boxShadow = 'none';
                                            }}
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowPassword(!showPassword)}
                                            style={{
                                                position: 'absolute',
                                                right: 8,
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                background: 'transparent',
                                                border: 'none',
                                                color: C.txt4,
                                                cursor: 'pointer',
                                                padding: 6,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                borderRadius: 4,
                                            }}
                                            title={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                                        >
                                            {showPassword ? (
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                                                    <line x1="1" y1="1" x2="23" y2="23" />
                                                </svg>
                                            ) : (
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                                    <circle cx="12" cy="12" r="3" />
                                                </svg>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            )}

                            {/* Link recuperar / cancelar */}
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: -4 }}>
                                {!isRecovering ? (
                                    <span
                                        onClick={() => {
                                            setIsRecovering(true);
                                            setMsgErrorLogin('');
                                            setUserVal(true);
                                            setIsSuccess(false);
                                        }}
                                        style={{
                                            fontSize: 13,
                                            color: C.bl,
                                            cursor: 'pointer',
                                            fontWeight: 500,
                                        }}
                                    >
                                        ¿Olvidaste tu contraseña?
                                    </span>
                                ) : (
                                    <span
                                        onClick={() => {
                                            setIsRecovering(false);
                                            setMsgErrorLogin('');
                                            setUserVal(true);
                                            setIsSuccess(false);
                                        }}
                                        style={{
                                            fontSize: 13,
                                            color: C.bl,
                                            cursor: 'pointer',
                                            fontWeight: 500,
                                        }}
                                    >
                                        ← Volver al inicio de sesión
                                    </span>
                                )}
                            </div>

                            {/* Botón submit */}
                            <div style={{ marginTop: 8 }}>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', padding: '12px 0' }}>
                                        <LoadSimple />
                                    </div>
                                ) : (
                                    <button
                                        onClick={isRecovering ? handleRecovery : handleSubmit}
                                        disabled={disabled}
                                        style={{
                                            width: '100%',
                                            height: 44,
                                            background: disabled ? C.wh : C.bl,
                                            color: disabled ? C.txt4 : C.wh,
                                            border: disabled ? `1px solid ${C.b1}` : 'none',
                                            borderRadius: 8,
                                            fontSize: 14,
                                            fontWeight: 600,
                                            cursor: disabled ? 'not-allowed' : 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: 8,
                                            transition: 'all 0.15s',
                                            letterSpacing: '0.01em',
                                            boxShadow: disabled ? 'none' : '0 1px 2px rgba(15,45,94,0.1)',
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!disabled) {
                                                e.currentTarget.style.background = '#1e40af';
                                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(15,45,94,0.18)';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!disabled) {
                                                e.currentTarget.style.background = C.bl;
                                                e.currentTarget.style.boxShadow = '0 1px 2px rgba(15,45,94,0.1)';
                                            }
                                        }}
                                    >
                                        {isRecovering ? 'Enviar correo' : 'Iniciar sesión'}
                                        {!disabled && (
                                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                <line x1="5" y1="12" x2="19" y2="12" />
                                                <polyline points="12 5 19 12 12 19" />
                                            </svg>
                                        )}
                                    </button>
                                )}
                            </div>

                            {/* Mensaje de error / éxito */}
                            {userVal === false && (
                                <div
                                    style={{
                                        padding: '10px 14px',
                                        background: isSuccess ? C.grSoft : C.redSoft,
                                        border: `1px solid ${isSuccess ? C.gr : C.red}`,
                                        borderRadius: 8,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 10,
                                    }}
                                >
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke={isSuccess ? C.gr : C.red}
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        style={{ flexShrink: 0 }}
                                    >
                                        {isSuccess ? (
                                            <>
                                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                                <polyline points="22 4 12 14.01 9 11.01" />
                                            </>
                                        ) : (
                                            <>
                                                <circle cx="12" cy="12" r="10" />
                                                <line x1="12" y1="8" x2="12" y2="12" />
                                                <line x1="12" y1="16" x2="12.01" y2="16" />
                                            </>
                                        )}
                                    </svg>
                                    <span
                                        style={{
                                            fontSize: 13,
                                            color: isSuccess ? C.gr : C.red,
                                            fontWeight: 500,
                                            lineHeight: 1.4,
                                        }}
                                    >
                                        {msgErrorLogin}
                                    </span>
                                </div>
                            )}
                        </div>

                        {/* Pie de seguridad */}
                        <div
                            style={{
                                marginTop: 28,
                                paddingTop: 18,
                                borderTop: `1px solid ${C.b1}`,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 6,
                                fontSize: 11,
                                color: C.txt4,
                            }}
                        >
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                            </svg>
                            Plataforma segura · Conexión cifrada
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;